<template>
    <!-- Header -->
    <DxToolbar style="height: 56px" class="toolbar">
        <DxItem location="before" locate-in-menu="never">
            <template #default>
                <routerVue :breadcrumbsItems="breadcrumbsItems" />
            </template>
        </DxItem>
    </DxToolbar>
    <!-- Content -->

    <div class="row pl-4">
        <div class="xs12">
            <DxDataGrid
                id="gridContainer"
                class="table-page"
                :remote-operations="true"
                :show-borders="true"
                :data-source="DanhSachNhanVien"
                :allow-column-resizing="true"
                :column-auto-width="true"
                :show-row-lines="true"
                ref="DanhSachNhanVien"
                :toolbar="{ visible: false }"
                :loadPanel="{ showIndicator: false, showPane: false, text: '' }"
                no-data-text="Không có dữ liệu!"
                height="calc(100vh - 56px)"
                @cellHoverChanged="onCellHoverChanged"
                @selection-changed="onSelectionChanged"
                :onEditorPreparing="onEditorPreparing"
                :onToolbarPreparing="onToolbarPreparing"
                :groupPanel="{ visible: 'auto' }"
                :stateStoring="{
                    enabled: true,
                    savingTimeout: 0,
                    storageKey: 'DanhSachNhanVien',
                    type: 'localStorage',
                }"
            >
                <DxHeaderFilter :visible="true" :allow-search="true" />
                <DxFilterRow :visible="true" applyFilter="onClick" />
                <DxPaging :page-size="50" />
                <DxScrolling mode="virtual" row-rendering-mode="virtual" />
                <DxColumnFixing :enabled="true" />
                <DxSelection
                    select-all-mode="allPages"
                    show-check-boxes-mode="always"
                    mode="multiple"
                />
                <DxColumn
                    data-field="HoTen"
                    caption="Tên nhân viên"
                    :fixed="true"
                    width="250px"
                />
                <DxColumn
                    data-field="TenDoanhNghiep"
                    caption="Doanh nghiệp"
                    :fixed="true"
                    width="250px"
                />
                <DxColumn
                    data-field="CCCD_HoChieu"
                    caption="CCCD/Hộ chiếu"
                    alignment="left"
                />
                <DxColumn data-field="SoDienThoai" caption="Số điện thoại" />
                <DxColumn data-field="KyHieuThe" caption="Ký hiệu thẻ" />
                <DxColumn data-field="MaThe" caption="Mã thẻ" />
                <DxColumn
                    :width="200"
                    alignment="left"
                    data-field="TenTrangThai"
                    caption="Trạng thái"
                    :fixed="true"
                    fixedPosition="right"
                />
                <DxSummary>
                    <DxTotalItem
                        column="HoTen"
                        summary-type="count"
                        display-format="Tổng: {0}"
                        :show-in-group-footer="true"
                        :align-by-column="true"
                    />
                </DxSummary>
                <!-- Hover button -->
                <DxColumn
                    cssClass="column-button-hover"
                    data-field="Detail"
                    caption="Trạng thái"
                    width="1"
                    cell-template="buttons-cell"
                    :fixed="true"
                    fixedPosition="right"
                ></DxColumn>
                <template #buttons-cell="{ data }">
                    <div class="buttons">
                        <DxButton
                            v-if="data.data.IdTrangThai == 1"
                            class="mx-1"
                            type="success"
                            stylingMode="text"
                            icon="mdi mdi-credit-card-plus-outline"
                            @click="CapTheChoNhanVien(data.data)"
                            hint="Cấp thẻ cho nhân viên"
                        ></DxButton>
                        <DxButton
                            v-if="data.data.MaThe"
                            class="mx-1"
                            type="danger"
                            stylingMode="text"
                            icon="mdi mdi-credit-card-remove-outline"
                            @click="HuyCapThe(data.data)"
                            hint="Hủy cấp thẻ"
                        ></DxButton>
                        <DxButton
                            v-if="data.data.IdTrangThai == 1"
                            class="mx-1"
                            icon="mdi mdi-pencil"
                            @click="SuaNhanVien(data.data)"
                            hint="Sửa"
                        ></DxButton>
                        <DxButton
                            v-if="data.data.IdTrangThai == 1"
                            class="mx-1"
                            icon="mdi mdi-delete"
                            @click="XoaNhanVien(data.data)"
                            hint="Xóa"
                        ></DxButton>
                    </div>
                </template>

                <DxToolbarGrid>
                    <DxItemGrid location="after" name="groupPanel" />
                    <DxItemGrid location="before" template="listButtonTemplate" />
                    <DxItemGrid location="before" name="applyFilterButton" />
                    <DxItemGrid location="before" name="columnChooserButton" />
                    <DxItemGrid location="before" template="refreshTemplate" />
                </DxToolbarGrid>
                <template #listButtonTemplate>
                    <div class="row align-center">
                        <DxButton
                            type="normal"
                            icon="mdi mdi-reload"
                            styling-mode="contained"
                            hint="Tải lại"
                            class="mx-1"
                            @click="TaiLai"
                        />
                        <DxButton
                            type="normal"
                            icon="mdi mdi-plus-circle"
                            styling-mode="contained"
                            class="mx-1"
                            @click="TaoMoiNhanVien"
                            hint="Tạo mới"
                        />

                        <DxButton
                            type="normal"
                            icon="mdi mdi-pencil"
                            styling-mode="contained"
                            class="mx-1"
                            @click="SuaNhanVien(this.arrSelected[0])"
                            :disabled="arrSelected.length != 1"
                            hint="Sửa"
                        />
                        <DxButton
                            type="normal"
                            icon="mdi mdi-delete"
                            styling-mode="contained"
                            class="mx-1"
                            :disabled="arrSelected.length != 1"
                            @click="XoaNhanVien(arrSelected[0])"
                            hint="Xóa"
                        />
                        <DxButton
                            type="normal"
                            icon="mdi mdi-file-excel"
                            styling-mode="contained"
                            class="mx-1"
                            hint="Xuất Excel"
                            @click="exportExcel"
                        />
                        <div
                            class="ml-2"
                            style="width: 1px; height: 24px; background: #03a9f4"
                        ></div>
                    </div>
                </template>
                <template #refreshTemplate>
                    <div class="row">
                        <DxButton
                            type="default"
                            styling-mode="text"
                            icon="mdi mdi-refresh"
                            hint="Khôi phục cài đặt gốc của bảng"
                            @click="onStateResetClick()"
                        />
                    </div>
                </template>
            </DxDataGrid>
        </div>
    </div>

    <DxPopup
        v-if="ifPopupXacNhan"
        v-model:visible="PopupXacNhan"
        :drag-enabled="false"
        :close-on-outside-click="false"
        :show-close-button="false"
        :show-title="false"
        :width="488"
        height="auto"
        @hidden="onHidden('PopupXacNhan')"
    >
        <PopupXacNhan :Params="ParamXacNhan" @click="XacNhan" />
    </DxPopup>

    <DxPopup
        v-if="ifPopupThongTinNhanVien"
        v-model:visible="PopupThongTinNhanVien"
        :drag-enabled="false"
        :close-on-outside-click="false"
        :show-title="false"
        width="688px"
        height="auto"
        @hidden="onHidden('PopupThongTinNhanVien')"
    >
        <PopupThongTinNhanVienVue @hiddenPopup="hiddenPopup" @getData="getData" />
    </DxPopup>

    <DxPopup
        v-if="ifPopupCapTheChoNhanVien"
        v-model:visible="PopupCapTheChoNhanVien"
        :drag-enabled="false"
        :close-on-outside-click="false"
        :show-title="false"
        width="888px"
        height="auto"
        @hidden="onHidden('PopupCapTheChoNhanVien')"
    >
        <PopupCapTheChoNhanVienVue @hiddenPopup="hiddenPopup" @getData="getData" />
    </DxPopup>

    <DxPopup
        v-if="ifPopupHuyCapTheChoNhanVien"
        v-model:visible="PopupHuyCapTheChoNhanVien"
        :drag-enabled="false"
        :close-on-outside-click="false"
        :show-title="false"
        width="488px"
        height="auto"
        @hidden="onHidden('PopupHuyCapTheChoNhanVien')"
    >
        <PopupHuyCapTheChoNhanVienVue @hiddenPopup="hiddenPopup" @getData="getData" />
    </DxPopup>
</template>

<script>
import DxToolbar, { DxItem } from "devextreme-vue/toolbar";
import routerVue from "@sonphat/common-v1/components/router.vue";
import { DxButton, DxPopup } from "devextreme-vue";
import { mapActions, mapState } from "vuex";
import PopupXacNhan from "@sonphat/common-v1/components/PopupXacNhan.vue";
import {
    DxDataGrid,
    DxColumn,
    DxSelection,
    DxFilterRow,
    DxHeaderFilter,
    DxSummary,
    DxPaging,
    DxTotalItem,
    DxColumnFixing,
    DxScrolling,
    DxToolbar as DxToolbarGrid,
    DxItem as DxItemGrid,
} from "devextreme-vue/data-grid";
import PopupThongTinNhanVienVue from "./components/PopupThongTinNhanVien.vue";
import PopupCapTheChoNhanVienVue from "./components/PopupCapTheChoNhanVien.vue";
import PopupHuyCapTheChoNhanVienVue from "./components/PopupHuyCapTheChoNhanVien.vue";

export default {
    components: {
        PopupThongTinNhanVienVue,
        PopupCapTheChoNhanVienVue,
        PopupHuyCapTheChoNhanVienVue,
        DxToolbar,
        DxItem,
        routerVue,
        DxButton,
        DxDataGrid,
        DxColumn,
        PopupXacNhan,
        DxPopup,
        DxSelection,
        DxFilterRow,
        DxSummary,
        DxTotalItem,
        DxColumnFixing,
        DxScrolling,
        DxToolbarGrid,
        DxItemGrid,
        DxHeaderFilter,
        DxPaging,
    },
    data() {
        return {
            NgungHoatDong: false,
            itemDangChon: null,
            DanhSachNhanVien: [],
            PopupXacNhan: false,
            ifPopupXacNhan: false,
            ParamXacNhan: {
                WidthTitle: "90%",
                Title: "Bạn có chắc chắn muốn xóa nhân viên đang chọn?",
                btnLeft: "HỦY",
                btnRight: "ĐỒNG Ý",
            },
            KeyXacNhan: null,
            arrSelected: [],
            breadcrumbsItems: [
                {
                    id: "breadcrums_DieuDo",
                    text: this.$t("stringRouter.QLTT"),
                    disabled: true,
                    to: "",
                },
                {
                    id: "breadcrums_DieuDo",
                    text: "Nhân viên",
                    disabled: true,
                    to: "",
                },
            ],
            ifPopupThongTinNhanVien: false,
            PopupThongTinNhanVien: false,
            ifPopupCapTheChoNhanVien: false,
            PopupCapTheChoNhanVien: false,
            ifPopupHuyCapTheChoNhanVien: false,
            PopupHuyCapTheChoNhanVien: false,
        };
    },

    computed: {
        ...mapState({
            DanhSachNhanVien: (state) => state.QuanLyNhanVien.DanhSachNhanVien,
        }),
    },
    created() {
        this.getData();
    },

    methods: {
        hiddenPopup(name) {
            this[name] = false;
        },
        onHidden(name) {
            this["if" + name] = false;
        },
        showPopup(name) {
            this["if" + name] = true;
            this[name] = true;
        },
        async getData() {
            this.$refs.DanhSachNhanVien?.instance.clearFilter();
            this.$refs.DanhSachNhanVien?.instance.clearSelection();
            try {
                this.DanhSachNhanVien = (
                    await this.$store.dispatch("NhanVien/LayDanhSachNhanVien")
                ).Store;
            } catch (error) {
                console.log("🚀 ~ error", error);
            }
        },
        TaiLai() {
            this.getData();
        },
        onEditorPreparing(e) {
            this.$Helper.Common.FilterRowWhenEnter(e);
        },
        onToolbarPreparing(e) {
            e.toolbarOptions.visible = true;
        },
        onStateResetClick() {
            this.$refs.DanhSachNhanVien.instance.state(null);
            setTimeout(() => {
                this.$refs.DanhSachNhanVien.instance.clearFilter();
                this.$refs.DanhSachNhanVien.instance.clearSelection();
                this.$refs.DanhSachNhanVien.instance.clearSorting();
            }, 100);
        },
        onCellHoverChanged(e) {
            this.$Helper.Common.table({ Element: e, Buttons: true }).HoverRow();
        },
        onSelectionChanged(e) {
            this.arrSelected = e.selectedRowsData;
        },
        TaoMoiNhanVien() {
            this.$store.commit("NhanVien/Reset_ThongTinNhanVien");
            this.showPopup("PopupThongTinNhanVien");
        },
        SuaNhanVien(e) {
            this.$store.commit("NhanVien/Set", {
                key: "ThongTinNhanVien",
                data: this.$Helper.Common.CloneData(e),
            });
            this.showPopup("PopupThongTinNhanVien");
        },
        CapTheChoNhanVien(e) {
            this.$store.commit("CapThe/Set", {
                key: "ThongTinCapThe",
                data: this.$Helper.Common.CloneData({
                    IdNhanVien: e.IdNhanVien,
                    IdThe: null,
                    DanhSachCong: null,
                }),
            });
            this.showPopup("PopupCapTheChoNhanVien");
        },
        exportExcel() {
            let init = {
                Element: this.$refs.DanhSachNhanVien.instance,
                FileName: "DanhSachNhanVien",
                WorkSheet: "Danh Sách",
            };
            this.$Helper.Common.excel(init).Export();
        },

        XoaNhanVien(data) {
            this.itemDangChon = data;
            this.KeyXacNhan = "XoaNhanVien";
            this.ParamXacNhan.Title = `Bạn có chắc chắn muốn xóa nhân viên "${data.HoTen}" đang chọn?`;
            this.showPopup("PopupXacNhan");
        },
        HuyCapThe(data) {
            this.$store.commit("CapThe/Set", {
                key: "ThongTinHuyCapThe",
                data: {
                    IdThe: null,
                    IdNhanVien: data.IdNhanVien,
                    LyDo: null,
                },
            });
            this.showPopup("PopupHuyCapTheChoNhanVien");
        },
        async XacNhan(bool) {
            if (bool == true) {
                if (this.KeyXacNhan == "XoaNhanVien") {
                    this.ThucHienXoaNhanVien();
                }
                this.itemDangChon = null;
                this.PopupXacNhan = false;
            } else if (bool == false) {
                this.itemDangChon = null;
                this.PopupXacNhan = false;
            }
        },
        async ThucHienXoaNhanVien() {
            try {
                this.$startLoading;
                const rs = await this.$store.dispatch(
                    "NhanVien/XoaNhanVien",
                    this.itemDangChon.IdNhanVien
                );
                if (rs.status) {
                    this.$Helper.ThongBaoToast(
                        "success",
                        "Xóa thông tin nhân viên thành công!"
                    );
                    this.getData();
                } else {
                    this.$Helper.ThongBaoPopup({
                        message_title: "Xóa thông tin nhân viên thất bại!",
                        message: rs.message,
                    });
                }
            } catch (error) {
                this.$Helper.ThongBaoPopup({
                    message_title: "Xóa thông tin nhân viên thất bại!",
                    message: "Lỗi hệ thống client",
                });
            } finally {
                this.$stopLoading;
            }
        },
    },
};
</script>

<style scoped></style>
